import { Button, Collapse, Divider, Form, Input, Select } from 'antd';
import type { ChangeEvent, ReactNode, RefObject } from 'react';
import { StudyLevel } from '../../Types/interfaces';
import { t } from 'i18next';
import { EmailListFormComponent } from './EmailListFormComponent';

interface StudyLineFormComponentProps {
  departmentNames: RefObject<Array<string>>;
  studyLineNames: RefObject<Array<Array<string>>>;
}

export const StudyLineFormComponent = ({
  departmentNames,
  studyLineNames,
}: StudyLineFormComponentProps): ReactNode => {
  const handleNameChange = (
    event: ChangeEvent<HTMLInputElement>,
    i: number,
    j: number
  ): void => {
    studyLineNames.current[i][j] = event.target.value; //eslint-disable-line
  };

  return (
    <>
      {departmentNames.current?.map((departmentName, index) => (
        <Collapse
          key={departmentName}
          items={[
            {
              key: departmentName + t('uniForm.slineComp.studyLine'),
              label: departmentName,
              children: (
                <Form.List name={['studyLines', index]}>
                  {(fields, fieldOperations) => (
                    <>
                      {fields.map((field) => (
                        <div key={field.key}>
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: t('validator.studyLineNameEmpty'),
                              },
                              {
                                validator: (_, value): Promise<void> => {
                                  return value === '' ||
                                    studyLineNames.current[index].filter(
                                      (name) => name === value
                                    ).length === 1
                                    ? Promise.resolve()
                                    : Promise.reject(
                                        new Error(t('validator.slineNameUsed'))
                                      );
                                },
                              },
                            ]}
                            name={[field.name, 'studyLineName']}
                          >
                            <Input
                              onChange={(event) =>
                                handleNameChange(event, index, field.name)
                              }
                              placeholder={t('uniForm.slineComp.name')}
                            />
                          </Form.Item>
                          <Form.Item
                            rules={[
                              {
                                required: true,
                                message: t(
                                  'validator.studyLineStudyLevelEmtpy'
                                ),
                              },
                            ]}
                            name={[field.name, 'studyLineLevel']}
                          >
                            <Select
                              options={[
                                {
                                  value: StudyLevel.Bachelor,
                                  label: 'Bachelor',
                                },
                                {
                                  value: StudyLevel.Master,
                                  label: 'Master',
                                },
                              ]}
                              placeholder={t('uniForm.slineComp.studyLevel')}
                            />
                          </Form.Item>
                          <EmailListFormComponent
                            propertyReference={'coordinators'}
                            parentReference={[field.name]}
                            buttonTitle={t('uniForm.slineComp.addCoordinator')}
                            emailType={t(
                              'uniForm.slineComp.coordinatorEmailType'
                            )}
                          />
                          <Divider />
                        </div>
                      ))}
                      <Button
                        style={{ margin: '1%' }}
                        type="primary"
                        onClick={() => {
                          fieldOperations.add();
                          const currentRefs = studyLineNames.current;

                          if (currentRefs) {
                            if (index === currentRefs.length) {
                              currentRefs.push([]);
                            } else if (currentRefs[index]) {
                              currentRefs[index].push('');
                            }
                          }
                        }}
                      >
                        {t('uniForm.slineComp.addStudyLine')}
                      </Button>
                    </>
                  )}
                </Form.List>
              ),
            },
          ]}
        />
      ))}
    </>
  );
};
